import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8 11v3a3 3 0 1 1-6 0v-3a3 3 0 0 1 6 0m-2 0v3a1 1 0 1 1-2 0v-3a1 1 0 1 1 2 0m7 6h1a3 3 0 1 1 0 6h-1a3 3 0 1 1 0-6m9-6v3a3 3 0 1 1-6 0v-3a3 3 0 1 1 6 0m-2 0v3a1 1 0 1 1-2 0v-3a1 1 0 1 1 2 0m-8 9a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4 13c.012.418 0 .6 0 1 0 .552-.397 1-.949 1a1 1 0 0 1-1-1c0-.284-.01-.637-.02-1.033a42 42 0 0 1-.02-2.43c.042-1.348.209-2.858.744-4.275.542-1.434 1.464-2.778 2.996-3.75C7.273 1.545 9.311 1 12 1s4.727.546 6.249 1.511c1.532.973 2.454 2.317 2.996 3.751.535 1.417.702 2.927.743 4.275.026.835.002 1.703-.018 2.43-.008.263-.014.508-.018.726A1 1 0 0 1 22 14v4.001c0 .101-.015.856-.579 1.604C20.818 20.406 19.741 21 18 21h-1a1 1 0 1 1 0-2h1c1.253 0 1.676-.402 1.824-.599.154-.205.174-.408.176-.422v-3.662c-.033-.1 0-.206 0-.317v-1c.02-.668.014-1.598-.01-2.402-.04-1.248-.192-2.508-.616-3.63-.417-1.103-1.093-2.067-2.197-2.768C16.062 3.493 14.425 3 12 3s-4.062.493-5.177 1.2c-1.104.7-1.78 1.665-2.197 2.769-.424 1.121-.577 2.38-.615 3.63A44 44 0 0 0 4 13",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }